import React, { useState } from "react";
import deadictions from "../../Images/deaddictionimage4.jpg";
import ServiceSlider from "../../commanfile/ServiceSlider";
import Servicelist from "../../commanfile/Servicelist";
import Button from "../../commanfile/Button";
import deadiction from "../../Images/deaddictionimage6.jpeg";
import { FaHandHoldingHeart } from "react-icons/fa6";
import comit from "../../Images/deaddictionimage2.jpg";

const Deaddiction = () => {
  const symtams1 = [
    "Strong cravings or urge to use the substance",
    "Inability to stop or control usage despite wanting to",
    "Neglecting responsibilities at work, school, or home",
    "Increased tolerance (needing more for the same effect)",
    "Withdrawal symptoms when not using (e.g., shaking, sweating, anxiety)",
  ];
  const symtams = [
    "Loss of interest in hobbies and social activities",
    "Risky behaviors (driving under influence, stealing, etc.)",
    "Relationship problems due to substance use",
    "Spending a lot of time obtaining, using, or recovering from the substance",
    "Denial or hiding use from others",
  ];

  const Data = [

    {
      question: "What is de-addiction treatment?  ",
      answer: "De-addiction treatment is a professional approach to help individuals overcome dependence on substances like drugs, alcohol, or tobacco. It includes detoxification, counseling, therapy, and medical support to remove addiction, manage withdrawal, address psychological causes, and support long-term recovery for a healthier life."
    },
    {
      question: "How do I know if I or my loved one needs de-addiction support? ",
      answer: "Signs of needing de-addiction support include strong cravings, increased tolerance, withdrawal symptoms, neglecting responsibilities, and continued use despite harm. Behavioral changes, secrecy, mood swings, and financial problems also indicate addiction. Early professional help improves recovery. If substance use causes loss of control or life impairments, seeking de-addiction support is crucial for health and well-being."
    },
    {
      question: "Is addiction a disease or just a lack of willpower? ",
      answer: "Addiction is classified as a chronic brain disease, not a lack of willpower. It involves changes in brain circuits that lead to compulsive substance use despite harmful consequences. Recognized by medical authorities like the American Psychiatric Association, addiction is a treatable condition requiring professional care, not simply a matter of personal choice or weakness."
    },
    {
      question: "	Can addiction be completely cured? ",
      answer: " Addiction cannot be completely cured but it is treatable and manageable like other chronic diseases. Treatment helps individuals stop using substances, regain control, and maintain recovery. Relapse can happen, but ongoing support and therapy improve long-term success. Lifelong management is often needed to prevent relapse and support sustained sobriety."
    },
    {
      question: "What are the first steps in seeking de-addiction treatment?",
      answer: "The first steps in seeking de-addiction treatment are recognizing and admitting the problem, then consulting a healthcare professional for assessment. Being honest about substance use and preparing questions helps. Support from family or friends and researching treatment options tailored to individual needs can guide recovery"
    },
    {
      question: "What treatment methods are available—detox, counseling, medications, or therapy?  ",
      answer: " Addiction treatment methods include detox to manage withdrawal, counseling, behavioral therapies (like cognitive-behavioral therapy), medications to reduce cravings or withdrawal symptoms, and supportive therapies such as motivational interviewing and 12-step programs. Holistic options like yoga or art therapy may also complement treatment."
    },
    {
      question: "How long does de-addiction treatment usually take?  ",
      answer: "De-addiction treatment usually takes about 30 to 90 days. Detoxification typically lasts 7 to 14 days, followed by counseling and therapy. Longer programs up to six months or more may be needed depending on the severity and individual needs. Ongoing aftercare supports lasting recovery."
    },
    {
      question: "Will the patient need to stay in a rehab center, or can it be outpatient? ",
      answer: " Both options are available. Patients with severe addiction or withdrawal symptoms often need to stay in inpatient rehab for 24/7 medical care and support. Outpatient treatment allows patients to live at home while attending therapy sessions, suitable for milder cases or after inpatient detox. The choice depends on severity and individual needs."
    },
    {
      question: "What withdrawal symptoms can one expect during recovery?  ",
      answer: " During recovery, withdrawal symptoms vary by substance but commonly include cravings, irritability, anxiety, sleep problems, depression, sweating, nausea, tremors, muscle aches, and headaches. Severe cases may experience seizures, hallucinations, or delirium, especially with alcohol or benzodiazepine withdrawal. Medical support is essential for safe management."
    },
    {
      question: "How important is family involvement in the recovery process?  ",
      answer: " Family involvement is crucial in addiction recovery. It improves treatment entry, completion, and outcomes by providing emotional support, accountability, and motivation. Family therapy helps heal relationships, build understanding, and create a supportive environment, which reduces relapse risk and fosters long-term sobriety. Recovering with family support significantly boosts success."
    },
    {
      question: "Can someone relapse after de-addiction treatment? What happens then? ",
      answer: "Yes, relapse after de-addiction treatment is common, occurring in about 40-60% of individuals, similar to other chronic illnesses. When relapse happens, it signals the need to reassess and adjust the treatment plan, not failure. Support and continued care help prevent relapse and promote sustained recovery"
    },
    {
      question: "Is de-addiction treatment confidential?  ",
      answer: " De-addiction treatment is highly confidential. Laws and regulations like HIPAA protect patient privacy, ensuring personal information and treatment details are kept secure. Confidentiality fosters trust, encourages open communication, and reduces stigma, allowing individuals to seek help safely. Information is shared only with consent or legal exceptions."
    },
    {
      question: "Does insurance cover de-addiction treatment? ",
      answer: " In India, health insurance now covers mental illnesses, including addiction treatment, following IRDAI regulations since 2018. Most plans cover inpatient detox, hospitalization, and rehabilitation at network hospitals. Outpatient counseling and medications may be covered if the policy includes OPD benefits. However, coverage for some de-addiction centers and complementary therapies might be limited, so checking specific policy details is important."
    },
    {
      question: "How can I support my loved one who is undergoing de-addiction therapy?  ",
      answer: " To support a loved one undergoing de-addiction therapy, express honest concern and listen without judgment. Encourage professional treatment and celebrate their recovery milestones. Avoid enabling addictive behaviors by setting healthy boundaries. Educate yourself about addiction, maintain open communication, and prioritize your own well-being to provide consistent, compassionate support throughout their journey."
    },

  ]

  const [isOpen, setisOpen] = useState("null")

  const togglefaqs = (index) => {
    setisOpen(isOpen === index ? null : index)
  }
  return (
    <>
      <div className="max-w-[1456px] mt-2 mx-auto ">
        <div className=" bg-[#448b7b] pb-8">
          <ServiceSlider
            classname={"flex flex-wrap sm:flex-nowrap px-3"}
            title={"Deaddiction"}
            content={
              "Addiction is not a failure, but a struggle that deserves compassion and care."
            }
            maincontent={
              "Recovery is never easy, but it is always possible—with patience, support, and hope. You are not defined by your addiction; you are defined by your courage to fight it. Every small step away from dependency is a giant leap toward freedom. Remember, you are not alone in this journey—healing is real, and a healthier, brighter tomorrow is within your reach."}
            buttonname={"Explore Treatment Option "}
            imgs={deadiction}
          />
        </div>



        <div className="sm:py-16 py-10">
          <div className="text-center border-b-4 max-w-7xl mx-auto">
            <p className="font-roboto sm:text-3xl text-2xl py-5">
              Is It Addiction? Know the Symptoms...
            </p>
            <div className="md:flex justify-center  items-center py-3 gap-6">
              <div className="content-center">
                <img src={deadictions} className="border-black  rounded-2xl w-[400px] sm:w-[500px] " />
              </div>

              <div className="text-center mx-auto sm:text-left ">
                <div className="lg:flex  px-2 pl-6 justify-center md:gap-10  ">
                  <Servicelist Symtams={symtams} />
                  <Servicelist Symtams={symtams1} />
                </div>
                <Button
                  className="text-black hover:text-white mt-5 mx-auto font-roboto text-[18px] bg-[#50b1a4] rounded-full px-4 py-2"
                  btnName={"Get Appointment"}
                  link={"/ContactUs"}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="mx-auto py-4">
          <div className="sm:flex justify-around pt-5 items-center">
            <div className="sm:w-[50%] w-full  ">
              <p className=" flex gap-2 font-roboto uppercase font-semibold text-3xl text-[#469B8F]">
                <FaHandHoldingHeart />
                Our support, every step of the way
              </p>

              <p className=" mx-auto text-justify text-lg py-2 px-5">
                A psychiatrist plays an essential role in de-addiction by providing comprehensive medical and psychological care for substance use disorders. Their responsibilities begin with an in-depth assessment, where they diagnose addiction and co-occurring mental health conditions such as depression or anxiety. Based on this, psychiatrists develop a personalized treatment plan combining medication—such as methadone for opioid dependence or antidepressants for mood issues—and evidence-based therapies like Cognitive Behavioral Therapy (CBT) or motivational interviewing.

              </p>
              <p className=" mx-auto text-justify text-lg py-2 px-5">
                Throughout detoxification and rehabilitation, psychiatrists supervise withdrawal management, address cravings, and monitor overall mental well-being. They work within multidisciplinary teams, collaborating with counsellors, psychologists, and social workers to ensure holistic care.

              </p>
              <p className=" mx-auto text-justify text-lg py-2 px-5">
                Psychiatrists also engage families where possible, provide psycho-education, and adjust treatment as needed to minimize relapse risk. Ultimately, their clinical expertise, ongoing support, and integrated approach help patients achieve lasting recovery and improved quality of life.
              </p>
            </div>
            <div className="">
              <img
                src={comit}
                className=" "
                alt="images"
              />
            </div>
          </div>
        </div>


        <div className="mx-auto md:pl-[40px] md:pr-[40px] p-2 pt-10">
          <div className="mx-auto">
            <p className="text-2xl font-bold text-center font-roboto">FAQs</p>
          </div>
          <div className="space-y-4 mt-4">
            {Data.map((faq, index) => (
              <div key={index} className="border border-gray-200 w-[100%] mx-auto rounded-lg">
                <button
                  onClick={() => togglefaqs(index)}
                  className="w-full text-left px-4 py-3 flex justify-between items-center focus:outline-none"
                >
                  <span className="font-medium font-roboto">{faq.question}</span>
                  <span>{isOpen === index ? '-' : '+'}</span>
                </button>
                {isOpen === index && (
                  <div className="px-4 py-2 font-roboto text-justify text-gray-600">{faq.answer}</div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Deaddiction;
